<template>
  <div class="container-fluid">
    <div class="row">
      <div class="col-6 col-sm-6 col-md-6">
        <form @submit.prevent="'return false'" >
          <div class="form-group" v-if="errors.length" >
            <ul class="list-group">
              <li class="list-group-item list-group-item-danger" v-for="error in errors" :key="error">{{ error }}</li>
            </ul>
          </div>
          <div class="form-group input-group-sm">
            <label >Nazwa produktu</label>
            <search-input
                v-model="form.productName"
                v-bind:items="productsNames"
              />
          </div>
          <div class="form-group input-group-sm">
            <label >Telefon kontaktowy</label>
            <input class="form-control" v-model="form.contactPhone"/>
          </div>
          <div class="form-group input-group-sm">
            <label >Opis reklamacji</label>
            <textarea class="form-control" v-model="form.description"></textarea>
          </div>
          <div class="form-group input-group-sm">
            <label >Dzień przyjęcia reklamacji</label>
            <datepicker 
                class="mt-1"
                v-model="form.createdAt"
                :monday-first="true"
                :language="lang"
            ></datepicker>
          </div>
          <input class="btn btn-success torre-btn btn-sm mr-2" type="button" value="Zapisz" @click="submit">
          <router-link class="btn btn-secondary btn-sm" :to="{ name: 'complaints' }">Anuluj</router-link>
        </form>
      </div>
    </div>
  </div>
</template>
<script>
import datepicker from 'vuejs-datepicker';
import {pl} from 'vuejs-datepicker/dist/locale'
import moment from 'moment'
import alertify from 'alertifyjs'
import restClient from '@/components/complaints/ComplaintsRestClient'
import validator from '@/components/complaints/Validator'
import service from '@/components/complaints/ComplaintsService'

export default {
  name: 'ComplaintsNew',
  components: {
    datepicker
  },
  data: function () {
    return {
      errors: [],
      productsNames: [],
      lang: pl,
      form: {
        productName: '',
        description: '',
        contactPhone: '',
        createdAt: moment().format("YYYY-MM-DD"),
      }
    }
  },
  created() {
    this.loadProductNames()
  },
  methods: {
    submit() {
      this.errors = []
      this.errors = validator.validate(this.form, this.productsNames)
      if (this.errors.length > 0) {
        return false
      }
      this.addComplain()
    },
    addComplain() {
      restClient
        .addComplain(this.form)
        .then(res => {
          service.notifyUser("Utworzono", this.form.productName)
          this.$router.push({name: 'complaints'})
        })
        .catch(err => {
          console.log(err)
        })
    },
    loadProductNames() {
      restClient.loadProductNames()
        .then(res => {
          this.productsNames = res.data
        })
        .catch(err => {
          console.log(err)
        })
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/components/complaints/ComplaintsNew.vue